<template>
	<div class="pages">
		<sub-ibox-title><p slot="title">群发管理</p></sub-ibox-title>
		<z-tab-bar :list-obj="tabBarParams.list" :active="tabBarParams.active" @handleClickTabBar = "handleClickTabBar"></z-tab-bar>
		<section class="content" v-show="tabBarParams.active != 'sendMassList'">
			<z-radio-material 
				:radio-bar-params ="radioBarParams" 
				:is-layer-material ="isLayerMaterial"
				@cancelMaterialLayer = "cancelMaterialLayer"
				@handleClickRadioBar ="handleClickRadioBar"
				@handleSetContent = "handleSetContent"
				>
			</z-radio-material>
			<div class="p-t-10 tips">
				<p v-show="tabBarParams.active=='kfSendMass'">重要提示：客服消息群发，用户必须是和当前公众号48小时之内有互动才能到达，此接口群发微信有监管风险，慎重使用。</p>
				<p v-show="tabBarParams.active=='wxSendMass'">重要提示：群发接口群发，服务号每月限制4条，订阅号每天1条，超出则不能发送成功，请慎重使用。</p>
				<p v-show="tabBarParams.active=='tpSendMass'">重要提示：模板消息群发，发送条数无限制，任何时候都能达到，但是滥用有封号风险，请慎重使用。</p>
			</div>
			<div class="m-t-20">
				<a class="z-btn z-btn-primary b-r-3" @click="handleSubmit">发送</a>
			</div>
		</section>
		<section v-show="tabBarParams.active=='sendMassList'">
			<list ref="list"></list>
		</section>
	</div>
</template>
<script>
	import List from "./WxMassList.vue";
	import { mapActions, mapState } from 'vuex'
	export default {
		name: 'WxMass',
		components: {
			List
		},
		data() {
			return {
				tabBarParams:{
					list:[{
						title:'微信群发',
						type:'wxSendMass'
					},{
						title:'客服消息群发',
						type:'kfSendMass'
					},{
						title:'已发送消息',
						type:'sendMassList'
					}],
					active:'wxSendMass' //默认
				},
				radioBarParams: {
					list: [{
						title: '文字',
						type: 'text',
						content:''
					}, {
						title: '图文',
						type: 'news',
						content:''
					}, {
						title: '图片',
						type: 'image',
						content:''
					}, {
						title: '语音',
						type: 'voice',
						content:''
					}, {
						title: '视频',
						type: 'video',
						content:''
					}],
					active: 'text' //默认
				},
				isLayerMaterial :false,//是否显示素材弹出层
				params:{
					sendType:'wxSendMass',//群发类型 
					msgType:'text', //消息类型
					content:'' //发送内容
				}
			}
		},
		/*
		 * 属性计算
		 */
		computed: {
		},
		/*
		 * 事件处理
		 */
		methods: {
			cancelMaterialLayer(){//显示隐藏弹出层
				this.isLayerMaterial = this.isLayerMaterial ? false : true
			},
			handleClickTabBar(type){//切换tabbar
				this.tabBarParams.active = type
				if(type == 'sendMassList'){
					this.$refs.list.handleGetMass()
				}
			},
			handleClickRadioBar(type){//切换radioBar
				this.radioBarParams.active = type
			},
			getKey(){//获取index
				switch (this.radioBarParams.active){
					case 'text': return 0
					case 'news': return 1
					case 'image':return 2
					case 'voice':return 3
					case 'video':return 4
					default: return null
				}
			},
			handleSetContent(content=null,type =null){//重置内容
				let index = this.getKey()
				this.radioBarParams.list[index].content = content
			},
			setParamsContent(){//获取需要保存的内容
				let index = this.getKey()
				this.params.sendType = this.tabBarParams.active 
				this.params.msgType = this.radioBarParams.active 
				let content = null
				switch (this.params.msgType){
					case 'text':
						content = this.radioBarParams.list[index].content.content
						break;
					case 'news':
						content = this.radioBarParams.list[index].content.mediaId || null
						if(!content) {
							content = this.radioBarParams.list[index].content.newsItem
							this.params.msgType = 'newsLink'
						}
						break;
					case 'image':
						content = this.radioBarParams.list[index].content.content.mediaId
						break;
					case 'voice':
						content = this.radioBarParams.list[index].content.content.mediaId
						break;	
					case 'video':
						content = this.radioBarParams.list[index].content.content.mediaId
						break;		
					default:
						break;
				}
				this.params.content = content
			},
			async handleSubmit(){//保存回复内容
				this.setParamsContent()
				if(!this.params.content) return this.$warning('请输发送内容唔/(ㄒoㄒ)/~~');
				try{
					await this.sendMass(this.params)
					this.$warning('发送成功')
				}catch(e){
					this.$log(e)
					this.$errorMsg('发送失败,请联系客服排查相关原因!');
				}
			},
			...mapActions(['sendMass']),
		}
	}
</script>
<style scoped lang="scss">
@import "src/assets/css/common.scss";
.tips{
	color: $color-red;
}
@media only screen and (min-width:0px) and (max-width:640px) {
	.tab-bar,.content,.sub-ibox-title {
		min-width: px-em(800px);
	}	
}
</style>


// WEBPACK FOOTER //
// WxMass.vue?3605d83b